import React, { useState } from "react";
// import { submitFirmDetails } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router";
import { initiatePayment } from "../../auth/services/privateapicalling";
import axios from "axios";
import useCommonServices from "../../../hooks/useCommonServices";


interface PaymentProps {
  onPrev: () => void;
  applicationId: string | null;
  existData: any;
  fetchApplicationExistenceCheck: () => Promise<void>;
}

const Payment
: React.FC <PaymentProps>= ({onPrev, applicationId,existData}) => {
 const language = useSelector((state:any)=>state.auth.language);
  const [showModal, setShowModal] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [captchaChecked, setCaptchaChecked] = useState(false);
  const [htmlContent, setHtmlContent] = useState<string>("");

    const {doPayment} = useCommonServices();
  
    //.log("applicationId", existData);
    const token = useSelector((state:any)=>state.auth.token)
    const userdetails = useSelector((state:any)=>state.auth.userDetails)
    const [paymentType, setPaymentType] = useState("NB");
    const appId = userdetails.applicationId
    const licenseType = "1";
    const entityType="FPO";
  const navigate = useNavigate();
  // Handle PDF Upload
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setUploadedFile(file);
      //.log("Uploaded File:", file.name);
    }
  };
  const handleRecaptchaChange = () => {
    //.log("reCAPTCHA token:");
    setCaptchaChecked(true);
  };
  // Navigate to Preview Screen
  const onPreview = () => {
    //.log("Navigating to preview screen...");
    // Add navigation logic here
    navigate(`/application/${applicationId}`);
  };

  // Handle Form Submission
  const goTopayment =async () => {
     try {
        
          const res = await doPayment(applicationId,paymentType,token);
          //.log("resss", res.data);

          const htmlText = await res.data.text();

          // Create a temporary container for the form
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = htmlText;

          // Find the form inside the response
          const form = tempDiv.querySelector('form[name="pgposting"]') as HTMLFormElement;

        if (form) {
          document.body.appendChild(form); // Append the form to the body (hidden)
          //.log("Submitting form...");
          form.submit();
        } else {
          //.error("Form not found in response!");
        }
          // const res = await initiatePayment(body , token)
          // //.log('resss', res.data)
          // const htmlText = await res.data.text();
          // setHtmlContent(htmlText);
          

        
        } catch (error) {
          //.error("Error fetching HTML:", error);
        }
    
    
   
   
  };

  const gotoMyApplication = ()=>{
    navigate('/my-applications' , );
  }

  const submitForm = () => {
    
    const form = document.querySelector('form[name="pgposting"]') as HTMLFormElement;
    if (form) {
      //.log("Submitting form...");
      form.submit(); 
    }
  };

  const getLicenseFee = (licenseType:string, entityType:string) => {
    if (licenseType === "1" && entityType !== "FPO") return 1000;
    if (licenseType === "3" && entityType !== "FPO") return 3000;
    if (licenseType === "1" && entityType === "FPO") return 500;
    return 1500;
};

  return (
    <>
 
    
   <div className="card">
      <div className="card-header">
        <h6 className="card-title">
        {language.payment_heading}-{`${applicationId}`}
        </h6>
      </div>
      <div className="card-body">
      <div className="row">

    <div className="d-flex flex-column align-items-center mt-3">
      <button type="button" className="btn btn-primary mb-4" onClick={onPreview}>
        {language.preview_application}
      </button>
      {/* <div className="fs-18 mb-4 mt-2">
        Your License Fee is <strong className="text-success">{getLicenseFee(licenseType, entityType)} </strong><span className="me-2">!!</span> <span className="text-danger">  Excluding GST</span>
      </div> */}
      {}
      <div className="mb-4">
        <label htmlFor="paymentOption" className="form-label">
          {language.select_payment_option}
        </label>
        <select
          id="paymentOption"
          className="form-select"
          value={paymentType}
          onChange={(e) => setPaymentType(e.target.value)}
        >
          <option value="NB">{"Net Banking"}</option>
          <option value="NB">{"Credit Card"}</option>
          <option value="NB">{"Debit Card"}</option>
          <option value="NB">{"WALLET"}</option>
          <option value="NB">{"Prepaid Cards"}</option>
          <option value="NB">{"CASH"}</option>
          <option value="NB">{"NEFT"}</option>
          <option value="NB">{"PAYPAL"}</option>
          <option value="NB">{"UPI"}</option>
        </select>
      </div>
      <div>
        <h3 className="mb-4">You are making a payment towards the License Fee.
This fee is required to obtain or renew your official license as per the applicable rules and regulations.</h3>
      </div>
      <button type="button" className="btn btn-info btn-lg p-2 fs-3 px-4" onClick={goTopayment}>
        {language.make_your_payment} {`₹ ${existData?.paymentFees}`}
      </button> <span className="text-danger mb-4">{language.ex_gst}</span>
      <button type="button" className="btn btn-danger" onClick={gotoMyApplication}>
       {language.cancel}
      </button>
    
    </div>


    </div>
    </div>
      </div>
      <button
        type="button"
        className="btn btn-secondary"
        onClick={onPrev}
      >
        {language.previous}
      </button>
    </>
   
  );
};

export default Payment
;